export const Orders = {
      "columns": 12,
      "rows": 3,
      "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": "colorTheme1",
        "title": "Orders",
        "binding": {
          "data": {
            "columns": [
              {
                "name": 'Order No.',
                "columnName": 'OrderNumber',
                "width": '150px',
                "align": "left",
                "sortable": true
              },              
              {
                "name": 'Order Date',
                "columnName": 'OrderDate',
                "width": '140px',
                "align": "left",
                "sortable": true
              },
              {
                "name": 'Customer Name',
                "columnName": 'Name',
                "width": '350px',
                "align": "left",
                "sortable": true
              },
              {
                "name": 'Delivery Address',
                "columnName": 'DeliveryAddress',
                "width": '450px',
                "align": "left",
                "sortable": true
              },              {
                "name": 'Total Amount',
                "columnName": 'NetTotal',
                "width": '150px',
                "align": "right",
                "sortable": true
              },
              {
                "name": 'Status',
                "columnName": 'Status',
                "width": '150px',
                "align": "center",
                "sortable": true
              },
              {
                "name": 'Created By',
                "columnName": 'CreatedBy',
                "width": '250px',
                "align": "left",
                "sortable": true
              }                          
            ],
            "title": 'Orders',
            "endpoint": "FF03",
            "parameters": [
              { "key": "FromMonth", "value": "2024" },
              { "key": "FromYear", "value": "1" },
              { "key": "ToMonth", "value": "2024" },
              { "key": "ToYear", "value": "1" }
            ]
          },
          "context": {
            "point": {
              "onClick": {
              }
            }
          }
        }
      }
}